import React from 'react';
import { Link } from 'react-router-dom';
import { GeneralContext } from '../../context/generalContext';
import '../Footer/Footer.scss';

export default function ReserveBtn({ isMobile }) {
  const { activeMenuItem, activeLanguage, setActiveMenuItem } = React.useContext(GeneralContext);

  const goToReserve = () => {
    window.scrollTo({
      top: 0,
    });
    setActiveMenuItem(3);
  };

  const getTextClassName = () => {
    if (!isMobile) return '';
    return activeMenuItem === 3 ? 'footer-fixed-btn-mobile--text-grey' : 'footer-fixed-btn-mobile--text-gold';
  };
  const textClassName = getTextClassName();

  return (
    <Link
      to={activeLanguage === 1 ? '/order' : '/en/order'}
      className={
        isMobile
          ? 'footer-fixed-btn-mobile footer-fixed-btn-mobile--reserve'
          : 'footer-fixed-btn footer-fixed-btn--reserve'
      }
      onClick={goToReserve}
    >
      <p className={textClassName}>{activeLanguage === 1 ? 'Резерв стола' : 'Reservations'}</p>
    </Link>
  );
}
